@if (!!depProject) {
  <div class="dep py-3 py-xxl-5">
    <app-carousel #moduleCarousel [title]="depProject.name">
      @for (module of depProject.modules; track trackModule($index, module)) {
        <div class="module">
          <div class="module-title">
            <h2>{{module.name}}</h2>
          </div>
          <div class="trainings d-flex">
            @for (training of module.trainings; track trackDepTraining($index, training)) {
              <div
                #trainingCards
                [attr.current]="isCurrentCard(training)"
                class="d-flex card">
                <app-training-card [training]="training.training" [isLocked]="isLocked(training.starts_at)"> </app-training-card>
              </div>
            }
          </div>
        </div>
      }
    </app-carousel>
  </div>
}
